exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".paddingTop25 {\n  padding-top: 25px;\n}\n.purchase-datepicker-Class div {\n  width: 100% !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/inventory/managePurchaseOrder/index.less
// module id = 3393
// module chunks = 0